import { API_DEPLOYMENT_V2 } from '../core/CcxEnv';
import { AuditLogResponse } from '../types/AuditLog';
import ApiService from './ApiService';

export type AuditLogParams = {
    from?: string;
    to?: string;
    limit?: number;
};

export default class DataStoreAuditLogService extends ApiService {
    static async getDataStoreAuditLog(
        dataStoreUuid: string,
        params?: AuditLogParams
    ): Promise<AuditLogResponse> {
        const response = await this.request(
            'GET',
            `data-stores/${dataStoreUuid}/audit`,
            { params }
        );
        return new AuditLogResponse(response);
    }

    protected static getApiUrl() {
        return API_DEPLOYMENT_V2;
    }
}
